import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "styled-components";

import GlobalStyle from "GlobalStyle";
import App from "components/App";
import theme from "theme";
import "i18n/i18n";

const Loader = () => (
  <div className="App">
    <div>loading...</div>
  </div>
);

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <GlobalStyle />
    <Suspense fallback={<Loader />}>
      <App />
    </Suspense>
  </ThemeProvider>,
  document.getElementById("root")
);
